export default "__VITE_ASSET__CEFM56zQ__"